import React from 'react';
import ReactDOM from 'react-dom';
import App1 from './App1';
import './index.css';
import axios from 'axios';


// Render the App1 component inside the root element
ReactDOM.render(<App1 />, document.getElementById('root'));
